import React, { Component, Fragment } from 'react';
import { Divider, Spin, Tabs, Card, Tag, Button, Carousel, Row, Col, message } from 'antd';
import { inject, observer } from 'mobx-react';
import moment from 'moment-timezone';
const TabPane = Tabs.TabPane;

@inject('store')
@observer
export class ListingView extends Component {
    constructor(props) {
        super(props);

        this.state = { listing: null };
    }

    async componentDidMount() {
        try {
            const { data } = await this.props.store.stratCenter.getListing(
                this.props.match.params.id
            );
            this.setState({ listing: data.listing });
        } catch (e) {}
    }

    caps(string) {
        return string.charAt(0).toUpperCase() + string.slice(1);
    }

    render() {
        if (!this.state.listing)
            return (
                <div style={{ padding: 50, textAlign: 'center' }}>
                    <Spin size={'large'} tip={'Loading...'} />
                </div>
            );
        const timezone = this.props.store.userStore.currentUser.timezone;
        const { listing } = this.state;

        return (
            <Fragment>
                <div style={{ background: '#2f2552', color: '#fff', padding: '25px 20px' }}>
                    <h1 style={{ color: '#fff' }}>
                        {listing.name} by {listing.author}
                    </h1>

                    <div style={{ marginBottom: 8 }}>
                        <b>Bot Type: </b>
                        <Tag color={'#a187ff'}>{this.caps(listing.bot_type || 'Apex')}</Tag>
                    </div>

                    <div style={{ marginBottom: 8 }}>
                        <b>Supported Base: </b>
                        {listing.supported_base.map(a => (
                            <Tag key={a}>{a}</Tag>
                        ))}
                    </div>
                    <div style={{ marginBottom: 8 }}>
                        <b>Tags: </b>
                        {listing.tags.map(a => (
                            <Tag key={a}>{a}</Tag>
                        ))}
                    </div>
                    <div style={{ fontSize: 12 }}>
                        Last updated:{' '}
                        {moment(listing.updated_at)
                            .tz(timezone)
                            .format('DD/MM/YYYY hh:mm:ss a')}
                    </div>
                    {/*<Rate/> 0 reviews*/}
                </div>

                <Row gutter={24}>
                    <Col md={24}>
                        <Tabs defaultActiveKey="1">
                            <TabPane tab="Description" key="1">
                                {listing.description.split('\n').map((item, i) => {
                                    return <p key={i}>{item}</p>;
                                })}
                            </TabPane>
                            <TabPane tab="Setup" key="2">
                                {listing.setup_guide.split('\n').map((item, i) => {
                                    return <p key={i}>{item}</p>;
                                })}
                            </TabPane>
                            <TabPane tab="Screenshots" key="3">
                                <Carousel dots adaptiveHeight>
                                    {listing.screenshots.map((file, i) => {
                                        return (
                                            <div key={i}>
                                                <img
                                                    src={file.src}
                                                    style={{ maxWidth: '100%' }}
                                                    alt="screenshot"
                                                />
                                            </div>
                                        );
                                    })}
                                </Carousel>
                            </TabPane>
                        </Tabs>
                    </Col>
                </Row>

                <Divider orientation={'left'}>Release History</Divider>

                {listing.versions
                    .filter(version => version.published)
                    .reverse()
                    .map((version, key) => {
                        return (
                            <Card
                                key={key}
                                size={'small'}
                                bordered={false}
                                title={`Version: ${version.version}`}
                                extra={
                                    <Button
                                        type={'primary'}
                                        onClick={() => {
                                            this.props.store.stratCenter.clone(
                                                listing._id,
                                                version.version,
                                                listing.bot_type === 'odyssey'
                                            );
                                            message.success('Strategy cloned');
                                        }}
                                    >
                                        Clone Package
                                    </Button>
                                }
                            >
                                {version.update_notes.split('\n').map((item, i) => {
                                    return <p key={i}>{item}</p>;
                                })}
                                <h4>Strategies</h4>

                                {version.strategies.map((strategy, stratKey) => {
                                    return (
                                        <div
                                            style={{ marginLeft: 10, marginBottom: 5 }}
                                            key={stratKey}
                                        >
                                            {this.renderType(strategy.type)} {strategy.name}{' '}
                                        </div>
                                    );
                                })}
                            </Card>
                        );
                    })}
            </Fragment>
        );
    }

    renderType(text) {
        switch (text) {
            case 'buy_sell':
                return <Tag>Buy/Sell</Tag>;
            case 'trigger':
                return <Tag>Automation</Tag>;
            case 'adca':
                return <Tag>ADCA</Tag>;
            case 'art':
                return <Tag>ART</Tag>;
            case 'signal':
                return <Tag>Signal</Tag>;
            case 'odyssey_short':
                return <Tag>Short</Tag>;
            case 'odyssey_long':
                return <Tag>Long</Tag>;
            default:
                return null;
        }
    }
}



// WEBPACK FOOTER //
// ./src/Account/StratCenter/Listing/index.js